<div class="app-main__inner">
  <div class="bb-settings-wrap">
    <div class="card bb-settings-card">

      <div class="card-header d-flex align-items-center gap-2">
        <button *ngIf="returnTo" type="button" class="btn btn-sm btn-outline-secondary" (click)="goBack()">
          <i class="pe-7s-back me-1"></i>Back
        </button>
        <i class="pe-7s-file text-primary"></i>
        <span class="fw-semibold">Book Catalogue PDF</span>
      </div>

      <div class="card-body">
        <p class="text-muted small mb-4">
          Choose the books to include and download a ready-made A4 PDF catalogue with book name, authors, and categories.
          Large catalogues may take 1–3 minutes to generate.
        </p>

        <!-- Filter options -->
        <div class="bc-options">

          <div *ngFor="let opt of filterOptions"
               class="bc-option-card"
               [class.selected]="filter === opt.value"
               (click)="filter = opt.value">
            <div class="bc-radio">
              <input type="radio" name="catalogueFilter" [value]="opt.value" [(ngModel)]="filter">
            </div>
            <div class="bc-option-body">
              <div class="bc-option-label">{{ opt.label }}</div>
              <div class="bc-option-desc">{{ opt.description }}</div>

              <!-- Count input for 'latest' -->
              <div *ngIf="opt.value === 'latest' && filter === 'latest'" class="bc-count-row" (click)="$event.stopPropagation()">
                <label class="bc-count-label">Number of books:</label>
                <input type="number" class="form-control form-control-sm bc-count-input"
                       [(ngModel)]="latestCount" min="1" max="2000" placeholder="e.g. 50">
              </div>
            </div>
          </div>

        </div>

        <!-- Error -->
        <div class="alert alert-danger py-2 px-3 small mt-4" *ngIf="errorMessage">
          <i class="pe-7s-attention me-1"></i>{{ errorMessage }}
        </div>

        <!-- Success banner -->
        <div class="bc-success mt-4" *ngIf="successMessage">
          <div class="bc-success__icon">
            <i class="pe-7s-check"></i>
          </div>
          <div class="bc-success__body">
            <div class="bc-success__title">PDF downloaded successfully!</div>
            <div class="bc-success__file">
              <i class="pe-7s-file me-1"></i>{{ successMessage }}
            </div>
            <div class="bc-success__hint">
              Check your browser's <strong>Downloads</strong> folder or the download bar at the bottom of your browser window.
            </div>
          </div>
          <button type="button" class="btn-close ms-auto" (click)="dismissSuccess()"></button>
        </div>

        <!-- Generate button -->
        <div class="mt-4">
          <button type="button" class="btn btn-primary"
                  (click)="generate()" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isLoading" class="pe-7s-cloud-download me-2"></i>
            {{ isLoading ? 'Generating…' : 'Download PDF' }}
          </button>
        </div>

        <!-- Progress indicator -->
        <div class="bc-progress-wrap mt-3" *ngIf="isLoading">
          <div class="progress bc-progress-bar">
            <div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div>
          </div>
          <small class="text-muted mt-1 d-block bc-progress-msg">{{ loadingMessage }}</small>
        </div>

      </div>
    </div>
  </div>
</div>
